<div class="grid grid-cols-1">
  <div class="flex flex-col gap-2">
    <label for="pesel">PESEL</label>
    <input
      [formControl]="formGroup()!.controls.pesel"
      appControlError
      id="pesel"
      pInputText
      readonly
    />
  </div>
  <div class="flex flex-col gap-2">
    <label for="email">Adres e-mail</label>
    <input
      [formControl]="formGroup()!.controls.email"
      appControlError
      id="email"
      pInputText
      readonly
    />
  </div>
  <div class="flex flex-col gap-2">
    <span id="role">Rola</span>
    <p-select
      [formControl]="formGroup().controls.role"
      [options]="organizationMemberRoleOptions"
      appControlError
      appendTo="body"
      class="w-full"
      ariaLabelledBy="role"
      optionLabel="label"
      optionValue="value"
      placeholder="Wybierz rolę"
    />
  </div>
  @if (formGroup().controls.role.value === RolaReprezentantaOrganizacji.OUP) {
    <p-card header="Instytucje" class="custom-card">
      <div class="wide">
        <p-table
          [value]="formGroup().controls.instytucje.controls"
          [paginator]="false"
          [tableStyle]="{ 'min-width': '50rem' }"
          styleClass="customPrimeTable"
        >
          <ng-template #header>
            <tr>
              <th style="width: 2rem; text-align: center">Wybierz</th>
              <th>Nazwa</th>
            </tr>
          </ng-template>

          <ng-template #body let-ctrl let-i="rowIndex">
            <tr>
              <td style="width: 2rem; text-align: center">
                <p-checkbox
                  [formControl]="ctrl"
                  [binary]="true"
                  [inputId]="'inst-' + i"
                ></p-checkbox>
              </td>
              <td>
                <label [for]="'inst-' + i">{{
                  authService.getSelectedOrganization()?.listaInstytucji?.[i]
                    ?.nazwa
                }}</label>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
    <div class="mt-2 p-2">
      <app-error-summary
        [errors]="formGroup().errors | errorMessages"
      ></app-error-summary>
    </div>
  }
  <p-card header="Pełnomocnictwo" class="custom-card">
    <div class="wide">
      <p-table
        [paginator]="false"
        [tableStyle]="{ 'min-width': '50rem' }"
        [value]="organizationRepresentativeAttachment()"
        styleClass="customPrimeTable"
      >
        <ng-template #header>
          <tr>
            <th style="width: 30%">Nazwa</th>
            <th style="width: 30%">Data utworzenia</th>
            <th style="width: 10%">Akcje</th>
          </tr>
        </ng-template>
        <ng-template #body let-attachment>
          <tr>
            <td>{{ attachment.nazwa }}</td>
            <td>
              {{ attachment.dataUtworzenia | date: 'yyyy-MM-dd HH:mm:ss' }}
            </td>
            <td>
              <div class="flex gap-4">
                <p-button
                  type="button"
                  (click)="downloadAttachment(attachment)"
                  ariaLabel="Pobierz"
                  pTooltip="Pobierz"
                  tooltipPosition="top"
                  [rounded]="true"
                  [text]="true"
                >
                  <i class="pi pi-download icon" aria-hidden="true"></i>
                </p-button>
                <p-button
                  type="button"
                  (click)="openDeletePowerOfAttorneyDialog(attachment)"
                  ariaLabel="Usuń"
                  pTooltip="Usuń"
                  tooltipPosition="top"
                  [rounded]="true"
                  [text]="true"
                >
                  <i class="pi pi-trash icon" aria-hidden="true"></i>
                </p-button>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
      <div class="flex mt-4">
        <p-fileupload
          (onSelect)="onUpload($event)"
          chooseIcon="pi pi-upload"
          chooseLabel="Dodaj pełnomocnictwo"
          aria-label="Dodaj pełnomocnictwo"
          mode="basic"
          styleClass="customFileupload"
          [auto]="true"
          [multiple]="false"
          [customUpload]="true"
          [showUploadButton]="false"
          [showCancelButton]="false"
          [maxFileSize]="1000000"
          [invalidFileSizeMessageSummary]="'{0}:'"
          [invalidFileSizeMessageDetail]="'Nieprawidłowy rozmiar pliku. Maksymalny rozmiar: 1 MB.'"
        />
      </div>
    </div>
    <div class="narrow">
      <div class="flex flex-col gap-10">
        @for (
          attachment of organizationRepresentativeAttachment();
          track attachment.id
        ) {
          <p-card class="custom-card">
            <div class="flex flex-col">
              <app-preview-data-wrapper
                label="Nazwa"
                [data]="attachment.nazwa"
              ></app-preview-data-wrapper>
              <hr class="limiter" />
              <app-preview-data-wrapper
                label="Rozmiar"
                [data]="attachment.rozmiar"
              ></app-preview-data-wrapper>
              <div class="flex justify-end gap-5 mt-5">
                <p-button
                  label="Pobierz"
                  type="button"
                  styleClass="customInfoButton outlined"
                  (click)="downloadAttachment(attachment)"
                />
                <p-button
                  label="Usuń"
                  type="button"
                  styleClass="customDangerButton"
                  (click)="openDeletePowerOfAttorneyDialog(attachment)"
                />
              </div>
            </div>
          </p-card>
        }
      </div>
    </div>
  </p-card>
</div>
<div class="flex justify-end gap-5 mt-5">
  <p-button
    (click)="dynamicDialogRef.close()"
    label="Anuluj"
    styleClass="customInfoButton outlined"
  />
  <p-button (click)="save()" label="Zapisz" styleClass="customInfoButton" />
</div>
